import { ReturnFlightJourney } from '@shared/v2/services/types/api/parsedResponse';

const getPrice = (flightOption: ReturnFlightJourney) =>
  Number(flightOption.charges.total.amount);

export const getCheapestReturnFlightJourney = (
  flightOptions: ReturnFlightJourney[],
) => {
  if (flightOptions.length === 0) {
    return undefined;
  }

  return flightOptions.reduce((cheapestFlightOption, currentFlightOption) => {
    if (getPrice(currentFlightOption) < getPrice(cheapestFlightOption)) {
      return currentFlightOption;
    }

    return cheapestFlightOption;
  });
};
